<app-relatorio-container
    tituloRelatorio="Ofício de Deferimento"
    descricaoRelatorio="Ofício de deferimento do pedido de registro da empresa"
    categoriaRelatorio="Cadastro"
    [filtrosTemplate]="filtrosTemplate"
    [pdfBlob]="(job$ | async)?.pdfBlob"
    [pdfFileName]="(job$ | async)?.fileName ?? 'oficio-deferimento-pj.pdf'"
    [statusPreview]="(job$ | async)?.status ?? null"
    [progressoPreview]="(job$ | async)?.progress ?? 0"
>
    <ng-template #filtrosTemplate>
        <div class="flex flex-col gap-6">
            <p class="text-sm">O ofício é emitido para o prestador atualmente selecionado, informando as providências necessárias para o recebimento do Certificado de Inscrição de Empresa.</p>

            <div class="field pt-5 flex justify-end gap-2">
                <p-button label="Limpar" icon="pi pi-eraser" [variant]="'text'" (click)="limparFormulario()"></p-button>
                <p-button label="Gerar Ofício" icon="pi pi-file-pdf" [appCan]="roleGerar" (click)="gerarRelatorio()" [loading]="isPending" [disabled]="isPending"></p-button>
            </div>
        </div>
    </ng-template>
</app-relatorio-container>
